import { jsx as t } from "react/jsx-runtime";
import { useRef as B, useCallback as b } from "react";
import { TextProvider as z } from "../../../context/Text.js";
import "styled-components";
import { useThemeInMode as S } from "../../../context/theme/hooks.js";
import { useTypography as T, TypographyProvider as H } from "../../../context/Typography.js";
import { getToneContentColorRole as v } from "../../../styles/colors/content/getToneContentColorRole.js";
import { typographyBodySizeMap as F, typographyBodyLineHeightMap as M } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import P from "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import R from "../utils/getLinkStyles.js";
function W({
  children: n,
  onClick: p,
  disabled: e = !1,
  size: m,
  lineHeight: a,
  tone: l = "primary",
  emphasis: s = "high",
  onHighEmphasisSurface: y = !1,
  disableInteractiveStyles: c = !1,
  underline: f = !1,
  fontWeight: h = "bold"
}) {
  const r = B(), u = S()[v({
    tone: l,
    emphasis: s,
    onHighEmphasisSurface: y
  })], g = R(
    e,
    c,
    f,
    h
  ), {
    typographyBodySize: d,
    lineHeight: x
  } = T(), i = m || d || "medium", C = a || x || "small", k = b((o) => {
    r.current && (o.key === "Enter" || o.key === " ") && (o.preventDefault(), r.current.click());
  }, []);
  return /* @__PURE__ */ t(
    P,
    {
      component: "span",
      UNSAFE_role: "button",
      tabindex: 0,
      onClick: (o) => {
        !e && p(o);
      },
      onKeyDown: k,
      ref: r,
      ...F[i],
      ...M[C],
      color: u,
      backgroundColor: "transparent",
      borderColor: "transparent",
      cursor: "pointer",
      ...g,
      children: /* @__PURE__ */ t(z, { value: !0, children: /* @__PURE__ */ t(H, { value: { typographyBodySize: i }, children: n }) })
    }
  );
}
export {
  W as default
};
